import { Control, Description, ErrorMessage, Indicator, Input, Label, Root } from "@kobalte/core/checkbox"
import { Show, splitProps } from "solid-js"
import type { ComponentProps, JSX, ParentProps } from "solid-js"
import { Icon } from "../../icons/icon/icon"

export interface CheckboxProps extends ParentProps<ComponentProps<typeof Root>> {
  hideLabel?: boolean
  description?: string
  icon?: JSX.Element
}

export function Checkbox(props: CheckboxProps) {
  const [local, others] = splitProps(props, ["children", "class", "label", "hideLabel", "description", "icon"])
  return (
    <Root {...others} data-component="checkbox">
      <Input data-slot="checkbox-checkbox-input" />
      <Control data-slot="checkbox-checkbox-control">
        <Indicator data-slot="checkbox-checkbox-indicator">
          {local.icon || <Icon name={props.indeterminate ? "dash" : "check"} size="small" />}
        </Indicator>
      </Control>
      <div data-slot="checkbox-checkbox-content">
        <Show when={props.children}>
          <Label data-slot="checkbox-checkbox-label" classList={{ "sr-only": local.hideLabel }}>
            {props.children}
          </Label>
        </Show>
        <Show when={local.description}>
          <Description data-slot="checkbox-checkbox-description">{local.description}</Description>
        </Show>
        <ErrorMessage data-slot="checkbox-checkbox-error" />
      </div>
    </Root>
  )
}
